import { 
  DashboardOutlined, 
  AppstoreOutlined,
  FileTextOutlined,
  PieChartOutlined,
  EnvironmentOutlined,
  AntDesignOutlined,
  SafetyOutlined,
  StopOutlined,
  DotChartOutlined,
  MailOutlined,
  MessageOutlined,
  CalendarOutlined,
  BulbOutlined,
  InfoCircleOutlined,
  CompassOutlined,
  LayoutOutlined,
  DesktopOutlined,
  FileDoneOutlined,
  CommentOutlined,
  RobotOutlined,
  PlusCircleOutlined,
  FundOutlined,
  ShoppingCartOutlined,
  BookOutlined,
  FileUnknownOutlined,
  CarOutlined,
  CoffeeOutlined,
  ProfileOutlined,
  UserOutlined,
  TeamOutlined,
  WifiOutlined,
  FileImageOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [{
  key: 'dashboards',
  path: `${APP_PREFIX_PATH}/dashboards`,
  title: 'sidenav.dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboards',
      path: `${APP_PREFIX_PATH}/dashboards`,
      title: 'sidenav.dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const dashBoarAnalyticsdNavTree = [{
  key: 'dashboards-analytics',
  path: `${APP_PREFIX_PATH}/dashboards`,
  title: 'sidenav.analytics',
  icon: DotChartOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboards-analytics',
      path: `${APP_PREFIX_PATH}/dashboards/analytics`,
      title: 'sidenav.analytics',
      icon: DotChartOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]


const dashBoardFinanceNavTree = [{
  key: 'dashboards-finance',
  path: `${APP_PREFIX_PATH}/dashboards`,
  title: 'sidenav.finance',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboards-finance',
      path: `${APP_PREFIX_PATH}/dashboards/finance`,
      title: 'sidenav.finance',
      icon: FundOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]
const UserNavTree = [{
  key: 'add-user',
  path: `${APP_PREFIX_PATH}/add-user`,
  title: 'sidenav.manageuser',
  icon: UserOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'add-user',
      title: 'sidenav.manageuser',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'add-user',
          path: `${APP_PREFIX_PATH}/add-user/new`,
          title: 'sidenav.add',
         
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'add-user-list',
          path: `${APP_PREFIX_PATH}/add-user/list`,
          title: 'sidenav.manange',
    
          breadcrumb: false,
          submenu: []
        },
        
      ]
    }
  ]
}]

const ActivityNavTree = [{
  key: 'activities',
  path: `${APP_PREFIX_PATH}/activities`,
  title: 'sidenav.activities',
  icon: EnvironmentOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'activities',
      title: 'sidenav.activities',
      icon: EnvironmentOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'activities-new',
          path: `${APP_PREFIX_PATH}/activities/new`,
          title: 'sidenav.add',
          
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'activities',
          path: `${APP_PREFIX_PATH}/activities/list`,
          title: 'sidenav.manange',
        
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'activities-bookings',
          path: `${APP_PREFIX_PATH}/activities/bookings`,
          title: 'sidenav.bookings',
        
          breadcrumb: false,
          submenu: []
        },
       
      ]
    }
  ]
}]

const VendorNavTree = [{
  key: 'vendors',
  path: `${APP_PREFIX_PATH}/vendors`,
  title: 'sidenav.vendors',
  icon: TeamOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'vendors',
   
      title: 'sidenav.vendors',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'vendors-add',
          path: `${APP_PREFIX_PATH}/vendors/new`,
          title: 'sidenav.add',
        
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'vendors',
          path: `${APP_PREFIX_PATH}/vendors/list`,
          title: 'sidenav.manange',
      
          breadcrumb: false,
          submenu: []
        },
       
      ]
    }
  ]
}]

const VendorMealNavTree = [{
  key: 'vendor-meals',
  path: `${APP_PREFIX_PATH}/vendor-meals`,
  title: 'sidenav.vendor-meals',
  icon: CoffeeOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'vendor-meals',
      title: 'sidenav.vendor-meals',
      icon: CoffeeOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'vendor-meals-add',
          path: `${APP_PREFIX_PATH}/vendor-meals/new`,
          title: 'sidenav.add',
         
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'vendor-meals',
          path: `${APP_PREFIX_PATH}/vendor-meals/list`,
          title: 'sidenav.manange',
         
          breadcrumb: false,
          submenu: []
        },
       
        
      ]
    },
   
  ]
}]

const VendorTransportsNavTree = [{
  key: 'vendor-transports',
  path: `${APP_PREFIX_PATH}/vendor-transports`,
  title: 'sidenav.vendor-transports',
  icon: CarOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'vendor-transports',
      title: 'sidenav.vendor-transports',
      icon: CarOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'vendor-transports-add',
          path: `${APP_PREFIX_PATH}/vendor-transports/new`,
          title: 'sidenav.add',
   
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'vendor-transports',
          path: `${APP_PREFIX_PATH}/vendor-transports/list`,
          title: 'sidenav.manange',
      
          breadcrumb: false,
          submenu: []
        },
       

      ]
    }
  ]
}]

const VendorAmenitiesNavTree = [{
  key: 'vendor-amenities',
  path: `${APP_PREFIX_PATH}/vendor-amenities`,
  title: 'sidenav.vendor-amenities',
  icon: WifiOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'vendor-amenities',
      title: 'sidenav.vendor-amenities',
      icon: WifiOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'vendor-amenities-add',
          path: `${APP_PREFIX_PATH}/vendor-amenities/new`,
          title: 'sidenav.add',
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'vendor-amenities',
          path: `${APP_PREFIX_PATH}/vendor-amenities/list`,
          title: 'sidenav.manange',
          breadcrumb: false,
          submenu: []
        },
        
      ]
    }
  ]
}]

const VendorsSlabNavTree = [{
  key: 'agent_slabs',
  path: `${APP_PREFIX_PATH}/agent_slabs`,
  title: 'sidenav.agent_slabs',
  icon: RobotOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'agent_slabs',
      title: 'sidenav.agent_slabs',
      icon: RobotOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'agent_slabs_new',
          path: `${APP_PREFIX_PATH}/agent_slabs/new`,
          title: 'sidenav.add',
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'agent_slabs_list',
          path: `${APP_PREFIX_PATH}/agent_slabs/list`,
          title: 'sidenav.manange',

          breadcrumb: false,
          submenu: []
        },
      
      ]
    }
  ]
}]

const DiscountsNavTree = [{
  key: 'discounts',
  path: `${APP_PREFIX_PATH}/discounts`,
  title: 'sidenav.discounts',
  icon: ShoppingCartOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'discounts',
      path: `${APP_PREFIX_PATH}/discounts/list`,
      title: 'sidenav.discounts',
      icon: ShoppingCartOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const LinkedActivitiesNavTree = [{
  key: 'activity_variations',
  path: `${APP_PREFIX_PATH}/activity_variations`,
  title: 'sidenav.activity_variations',
  icon: CompassOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'activity_variations',
      path: `${APP_PREFIX_PATH}/activity_variations/list`,
      title: 'sidenav.activity_variations',
      icon: CompassOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]


const OrdersNavTree = [{
  key: 'orders',
  path: `${APP_PREFIX_PATH}/orders`,
  title: 'sidenav.orders',
  icon: ShoppingCartOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'orders',
     
      title: 'sidenav.orders',
      icon: ShoppingCartOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'orders',
          path: `${APP_PREFIX_PATH}/orders/list`,
          title: 'sidenav.all',
   
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'orders_abnd_checkout',
          path: `${APP_PREFIX_PATH}/orders/list`,
          title: 'sidenav.ab_checkout',
         
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'orders_failed',
          path: `${APP_PREFIX_PATH}/orders/list`,
          title: 'sidenav.failed',
        
          breadcrumb: false,
          submenu: []
        },
      ]
    },
    
    
  ]
}]

const EmployeeNavTree = [{
  key: 'employee',
  path: `${APP_PREFIX_PATH}/employee`,
  title: 'sidenav.employee',
  icon: CompassOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'employee',
      path: `${APP_PREFIX_PATH}/employee/list`,
      title: 'sidenav.employee',
      icon: CompassOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const CustomerNavTree = [{
  key: 'customers',
  path: `${APP_PREFIX_PATH}/customers`,
  title: 'sidenav.customers',
  icon: TeamOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'customers',
      path: `${APP_PREFIX_PATH}/customers/list`,
      title: 'sidenav.customers',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const SalesAgentNavTree = [
  {
    key: "sales_agents",
    path: `${APP_PREFIX_PATH}/customers`,
    title: "sidenav.sales-agent",
    icon: TeamOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "sales_agents",
        // path: `${APP_PREFIX_PATH}/sales_agent/list`,
        title: "sidenav.sales-agent",
        icon: TeamOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "sales_agents-add",
            path: `${APP_PREFIX_PATH}/sales_agent/new`,
            title: "sidenav.add",

            breadcrumb: false,
            submenu: [],
          },
          {
            key: "sales_agents_list",
            path: `${APP_PREFIX_PATH}/sales_agent/list`,
            title: "sidenav.manange",

            breadcrumb: false,
            submenu: [],
          },
          { key: "sales_agents_orders",
            path: `${APP_PREFIX_PATH}/sales_agent/orders`,
            title: "sidenav.agent_orders",
            // icon: ShoppingCartOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "salse_agents_dashboard",
            path: `${APP_PREFIX_PATH}/sales_agent/dashboard`,
            title: "sidenav.agent_dashboard",
            // icon: DotChartOutlined,
            breadcrumb: false,
            submenu: [],
          },
          
        ],
      },
    ],
  },
];
const InvoicesNavTree = [{
  key: 'invoices',
  path: `${APP_PREFIX_PATH}/invoices`,
  title: 'sidenav.invoices',
  icon: FileImageOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'invoices',
      path: `${APP_PREFIX_PATH}/invoices/list`,
      title: 'sidenav.invoices',
      icon: FileImageOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const BookingsNavTree = [
  {
    key: "bookings",
    path: `${APP_PREFIX_PATH}/bookings`,
    title: "sidenav.bookings",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "bookings",
        path: `${APP_PREFIX_PATH}/bookings/list`,
        title: "sidenav.bookings",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];
const Timesheet = [
  {
    key: "timesheet",
    path: `${APP_PREFIX_PATH}/timesheet`,
    title: "sidenav.timesheet",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "timesheet",
        path: `${APP_PREFIX_PATH}/timesheet/list`,
        title: "sidenav.timesheet",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];


const navigationConfig = [
  ...dashBoardNavTree,
  ...dashBoarAnalyticsdNavTree,
  ...dashBoardFinanceNavTree,
  ...UserNavTree,
  ...ActivityNavTree,
  ...VendorNavTree,
  ...CustomerNavTree,
  ...SalesAgentNavTree,
  ...VendorsSlabNavTree,
  ...VendorMealNavTree,
  ...VendorTransportsNavTree,
  ...VendorAmenitiesNavTree,
  ...DiscountsNavTree,
  ...LinkedActivitiesNavTree,
  ...OrdersNavTree,
 ...BookingsNavTree,
  ...InvoicesNavTree,
  ...Timesheet
]

export default navigationConfig;